import moment from 'moment';
import type { IDateType } from '@/pages/intelligence/types/common';
import type { IRangePickerDefaultValue } from '../types';

export const DEFAULT_DATE_TYPES: IDateType[] = ['date', 'week', 'month'];

export const RANGE_PICKER_DEFAULT_VALUE: IRangePickerDefaultValue = {
  date: [moment().subtract(30, 'day'), moment()],
  week: [moment().subtract(7, 'week').startOf('week'), moment().endOf('week')],
  month: [moment().subtract(6, 'month').startOf('month'), moment().endOf('month')],
};
